/* eslint-disable padding-line-between-statements */
/* eslint-disable object-shorthand */
/* eslint-disable camelcase */
/* eslint-disable max-len */
import React, {
    useContext,
    useEffect,
    useState,
    useCallback,
    useRef
} from 'react';
import _ from 'lodash';
import moment from 'moment';
import appConfig from 'app-config';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { AvailabilityService } from 'gw-capability-policycommon';
import { MLOfferingService, MLProducerEligibilityService, UserService,OrganizationService} from 'gw-capability-gateway';
import { MLGeoCompleteService, MLBundleService, MLStateRolloutService } from 'ml-services-common-react';
import { platformMessages } from 'ml-components-platform-react';
import { MLPolicyTypeUtil , MLNotificationBlockUtil} from 'ml-portals-util-react';
import { MLProductCodeUtil, MLLocalDateUtil } from 'ml-portals-util-js';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import MLOrganizationTypeaheadSearch from './MLOrganizationTypeaheadSearch';

import metadata from './MLNewQuoteDialogModal.metadata.json5';
import messages from './MLNewQuoteDialogModal.messages';
import styles from './MLNewQuoteDialogModal.module.scss';

import { Button, CheckboxField, InputField, DropdownSelectField, DateField } from '@jutro/legacy/components';
import {MLPortalSettingsService} from "gw-capability-quoteandbind";

import { IntlContext } from '@jutro/legacy/locale';

const BUNDLED = 1;
const BUNDLE_UMB_ERROR_MSG = 'A bundle can only contain 1 Umbrella policy.';
const BUNDLE_ERROR_MSG_KEY = 'bundleError';
const allProductCodes = [
    MLProductCodeUtil.getPersonalAutoCode(),
    MLProductCodeUtil.getPersonalUmbrellaCode()
].concat(MLProductCodeUtil.getHomeOwnersPartialCoverages());

const modernProductCodes = [
    MLProductCodeUtil.getPersonalAutoCode(),
    MLProductCodeUtil.getPersonalUmbrellaCode()
].concat(MLProductCodeUtil.getHomeOwnersPartialCoverages());

function MLNewQuoteDialogModal(props) {
    const {
        model: account,isNewAccount, id, onSave, onCancel, history, viewModelService, authHeader, indicativeUmbInd, indicativeUmbPremium, indicativeAutoJobWithUmb
    } = props;
    const { MLUserTypes } = appConfig;
    const { refreshData } = useDataRefresh();
    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const producerCodeSecurity = account?.accountHolder?.useProducerCodeSecurity?.value
    const { onValidate: setComponentValidation } = useValidation(id);
    const [defaultProducerCode, updateDefaultProducerCode] = useState(undefined);
    const [producerCodeProducerType, updateProducerCodeProducerType] = useState(undefined);
    const [currentUser, updateCurrentUser] = useState(undefined);
    const [userType, updateUserType] = useState(undefined);
    const [newSubmissions, updateNewSubmissions] = useState([]);
    const [existingPolicies, updateExistingPolicies] = useState([]);
    const [bookRollQuotes, updateBookRollQuotes] = useState([]);
    const [errors, setErrors] = useState([]);
    const [isNewSubmissionAdded, setIsNewSubmissionAdded] = useState(false);
    const [selectedOrg, setSelectedOrg] = useState(null);
    const [producerCodeOfRecord_Ext, setProducerCodeOfRecord_Ext] = useState(null);   
    const [referralAgentId, setReferralAgentId] = useState(null);
    const [isAnotherOrg, setIsAnotherOrg] = useState(false);
    const [orgList, setOrgList] = useState([]);
    const [orgProducerCodes, setOrgProducerCodes] = useState([]);
    const isInitialProducerCodeValidated = useRef([])
    const [isProducerCodeChangedAutomatically ,setIsProducerCodeChangedAutomatically ] = useState(false);
    const errorsRef = useRef();
    let newProductStates;
    let homeNewProductStates;
    const [isNewProduct, setIsNewProduct] = useState([]);
    const [npStates, setNPStates] = useState([]);

    errorsRef.current = errors;

    const {
        showProgressDialog,
        showErrorModal,
        hideProgressDialog
    } = MLModalService();

    const {
      clearBlockAlerts,
      addWarningAlert
    } = MLNotificationBlockUtil();

    const openQuotes = _.get(account, 'openQuotes_ML.value', []);

    const invalidZipAlertNameML = 'invalidZip';
    const STRATEGIC_PARTNER = 'Y';

    const openQuotesEffDates = openQuotes.map(openQuote => openQuote.policyEffectiveDate);

    const latestOpenQuoteDate = new Date(Math.max(...openQuotesEffDates.map(Date.parse)));

    const initialSavedQuotes = openQuotes.map((quote) => {
        return viewModelService.create({
            accountNumber: account.accountNumber,
            effectiveDate: quote.policyEffectiveDate_ML,
            jobNumber: quote.jobNumber,
            postalCode_ML: _.get(quote, 'address_ML.postalCode'),
            productCode: MLProductCodeUtil.isHomeOwners(_.get(quote, 'product.publicID')) ? _.get(quote, 'product.coveragePartType_ML') : _.get(quote, 'product.publicID'),
            offeringCode_ML: quote.offering_ML,
            coveragePackageLevel_Ext: quote.coveragePackageLevel_Ext,
            bundleID: quote.bundleID_ML,
            producerCode: quote.producerCodeOfService,
            state: _.get(quote, 'address_ML.state'),
            producerContactFirstName_ML: quote.producerContactFirstName_ML,
            producerContactLastName_ML: quote.producerContactLastName_ML,
            isSubmitAgent: true,
            included: quote.bundleID_ML === BUNDLED || quote.preselected,
            totalPremium: quote.totalPremium,
            termType: quote.termType_ML,
            isCompRaterRequest: quote.isCompRaterRequest_ML,
            compRaterPremium: quote.compRaterPremium_ML,
            compRaterTermType: quote.compRaterTermType_ML,
            bookRollIndicator: quote.bookrollIndicator_ML,
            country: _.get(quote, 'address_ML.country'),
        },
        'pc',
        'metlife.edge.capabilities.bundling.dto.NewBundledSubmissionDTOML');
    });

    const [savedQuotes, updateSavedQuotes] = useState(initialSavedQuotes);

    const { getPolicyTypeName } = MLPolicyTypeUtil();
    const {
        getFirstAvailableOfferingForProduct,
        refreshOfferingsWithUserType,
        getAvailableOfferingsForProduct
    } = MLOfferingService();

    const getProductsAvailabilityArgs = (productCodes, submission) => {
        const availabilityParams = {
            effectiveDate: submission.effectiveDate.value,
            producerCode_Ext: _.get(submission, "producerCode.value"),
            postalCode: submission.postalCode_ML.value.substring(0, 5),
            productCode: MLProductCodeUtil.getHomeOwnersCode(),
            stateCode_ML: submission.value.state,
            productCodes: productCodes
        };
        return availabilityParams;
    };

    const hasAvailableProducts = (submission) => {
        return Array.isArray(submission.availableProducts) && submission.availableProducts.length > 0;
    };

    const addError = useCallback((key, message) => {
        const currErrors = [...errorsRef.current];
        const idx = currErrors.findIndex((error) => { return error.key === key; });
        if (idx > -1) {
            setErrors(currErrors.map((error) => {
                if (error.key === key) {
                    return { ...error, message: message };
                }
                return error;
            }));
        } else {
            setErrors([...currErrors, { key: key, message: message }]);
        }
    }, []);

    const removeError = useCallback((key) => {
        const currErrors = [...errorsRef.current];
        const idx = currErrors.findIndex((error) => { return error.key === key; });
        if (idx > -1) {
            setErrors(currErrors.filter((error) => error.key !== key));
        }
    }, []);

    const getAvailableProducts = useCallback(async (submission) => {
        const postCode = submission ? submission.postalCode_ML : null;
        const postCodeValid = postCode && postCode.aspects.valid && postCode.aspects.subtreeValid;

        const effectiveDate = submission ? submission.effectiveDate : null;
        const effectiveDateValid = effectiveDate && effectiveDate.aspects.valid && effectiveDate.aspects.subtreeValid;

        if (postCodeValid && effectiveDateValid) {
            try {
                showProgressDialog(platformMessages.loading, null, null, 0);
                
                const result = await MLGeoCompleteService.getState(postCode.value.substring(0, 5));
                _.set(submission, 'value.state', result.StateProvince);
                
                hideProgressDialog();

                let args;
                args = getProductsAvailabilityArgs(allProductCodes, submission);

                const availabilityPromise = AvailabilityService.getAvailableProductsBasedOnPostalCodeExt(args, authHeader);

                availabilityPromise.then((availabilityResult) => {
                    _.set(submission, 'availableProducts', availabilityResult);
                    refreshData();
                    if (!hasAvailableProducts(submission)) {
                        removeError(invalidZipAlertNameML);
                        addError('availableProducts', translator(messages.noProductAvailable));
                    } else {
                        removeError('availableProducts');
                        removeError(invalidZipAlertNameML);
                    }
                });

            } catch (e) {
                hideProgressDialog();
                removeError('availableProducts');
                addError(invalidZipAlertNameML, e);
            }
        }
    }, [addError, authHeader, hideProgressDialog, newProductStates, refreshData, removeError, showProgressDialog, translator]);

    const createNewSubmission = useCallback((type, tempDefaultProdCode) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        // US1071151: Default Effective Date to Current + 7 Days
        today.setDate(today.getDate() + 7);
        // DE254138 Bridged_Quote_Summary_Effective date is not defaulted to effective date of previously bridged comprater quote
        const defaultEffectiveDate =  (latestOpenQuoteDate?.toDateString() !== 'Invalid Date') ? MLLocalDateUtil.date2LocalDate(latestOpenQuoteDate) : MLLocalDateUtil.date2LocalDate(today);
        const defaultUmbEffDate = MLLocalDateUtil.date2LocalDate(latestOpenQuoteDate);

        const initialNewSubmissionVal = {
            effectiveDate: indicativeUmbInd ? defaultUmbEffDate : defaultEffectiveDate,
            producerCode: defaultProducerCode || tempDefaultProdCode,
            accountNumber: account.accountNumber,
            postalCode_ML: _.get(account, 'accountHolder.primaryAddress.postalCode.value'),
            country: _.get(account, 'accountHolder.primaryAddress.country.value'),
            userType_ML: type,
            isSubmitAgent: true,
            sameMailingAddress_ML: true,
            tempId: newSubmissions.length,
            included: true,
            bookRollIndicator: 'No',
            productCode: indicativeUmbInd ? 'PersonalUmbrella' : '',
            producerAutoUpdated_Ext: false,
            indicativeUmbrellaInd_Ext: indicativeUmbInd,
            indicativeUmbrellaPremium_Ext: indicativeUmbPremium,
            indicativeAutoJobNumber_Ext: indicativeAutoJobWithUmb
        };

        const newSubmission = viewModelService.create(
            initialNewSubmissionVal,
            'pc',
            'metlife.edge.capabilities.bundling.dto.NewBundledSubmissionDTOML'
        );

        updateNewSubmissions([...newSubmissions, newSubmission]);
        setIsNewSubmissionAdded(true);
        getAvailableProducts(newSubmission);
    }, [account, defaultProducerCode, getAvailableProducts, indicativeAutoJobWithUmb, indicativeUmbInd, indicativeUmbPremium, latestOpenQuoteDate, newSubmissions, viewModelService]);

    const initOfferings = useCallback((type) => {
        refreshOfferingsWithUserType(type);
    }, [refreshOfferingsWithUserType]);

    const initUser = useCallback(() => {
        UserService.getCurrentUser(authHeader, true).then((user) => {
            if (user.producerCodes_ML && user.producerCodes_ML.length) {
                _.set(user, 'producerCodes_ML', user.producerCodes_ML.filter((producerCode) => {
                    return producerCode.producerStatus_ML === 'Active';
                }));
            }
            const tempDefaultProducerCode = _.get(user, 'primaryProducerCode_ML.code');
            updateDefaultProducerCode(tempDefaultProducerCode);
            updateProducerCodeProducerType(_.get(user, 'primaryProducerCode_ML.producerType_ML'));
            updateCurrentUser(user);
            const type = user.userType;
            updateUserType(type);
            createNewSubmission(type, tempDefaultProducerCode);
            initOfferings(type);

            if (MLUserTypes.IA) {
                const selectedProducerCode = user?.producerCodes_ML.find((pCode) => pCode.code === user?.primaryProducerCode_ML?.code);

                if (selectedProducerCode != null && selectedProducerCode?.strategicPartnershipIndicator != null && selectedProducerCode?.strategicPartnershipIndicator?.toLowerCase() === "y") {
                    setSelectedOrg(selectedProducerCode)
                }
        }
        });
    }, [authHeader, createNewSubmission, initOfferings]);

    const initSettings = async() => {
        if (!newProductStates) {
            const response = await MLPortalSettingsService.getSettings(authHeader)
            if (response) {
                newProductStates = response.enableAuto50ProductStates;
                //home NP states
                homeNewProductStates = response.enableProperty50ProductStates;
                setIsNewProduct(homeNewProductStates);
                setNPStates([
                    ...(response.enableAuto50ProductStates?.split(',').map(state => state.trim()) || []),
                    ...(response.enableProperty50ProductStates?.split(',').map(state => state.trim()) || [])
                ]);
            }
        }
    };

    const clearStrategicPartnerData = () => {
        localStorage.removeItem('strategicPartnershipInd_Ext');
        localStorage.removeItem('referralAgentId');
        localStorage.removeItem('producerCodeOfRecord_Ext');
    };

    useEffect(() => {
        clearStrategicPartnerData()
        initUser();
        initSettings();
        updateBookRollQuotes(savedQuotes
            .filter((sub) => sub.value.bookRollIndicator === 'With Rate Capping' || sub.value.bookRollIndicator === 'Without Rate Capping'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isNewSubmissionAdded && newSubmissions.length > 1) {
            const prodcuerCodeInput = document.querySelector(`input[id^="producerCode_${newSubmissions.length - 1}"]`);
            const effDateInput = document.querySelector(`input[id^="effectiveDate_${newSubmissions.length - 1}"]`);
            if (prodcuerCodeInput) {
                prodcuerCodeInput?.focus();
            } else if (!prodcuerCodeInput && effDateInput) {
                effDateInput?.focus();
            }
            
            setIsNewSubmissionAdded(false);
        }
    }, [isNewSubmissionAdded, newSubmissions]);

    const isMetGAorIAorPCSAgent = () => {
        return userType === MLUserTypes.IA || userType === MLUserTypes.PCS || userType === MLUserTypes.MET_GA || (isAnotherOrg && MLUserTypes.GCS_SALES && selectedOrg?.strategicPartnershipIndicator === true);
    };

    const writeSubmissionValue = useCallback((value, path, item, index) => {
        const copiedSubmissions = [...newSubmissions];
        _.set(item, path, value);
        copiedSubmissions[index] = item;

        updateNewSubmissions(copiedSubmissions);
        return item;
    }, [newSubmissions]);

    const writeSavedQuotesValue = useCallback((value, path, item, index) => {
        const copiedSavedQuotes = [...savedQuotes];
        _.set(item, path, value);
        copiedSavedQuotes[index] = item;

        updateSavedQuotes(copiedSavedQuotes);
        return item;
    }, [savedQuotes]);

    const hasAvailableProducerCodes = () => {
        return currentUser.producerCodes_ML && currentUser.producerCodes_ML.length > 0;
    };

    const getProducerOfRecordCell = useCallback(
        (submission, index, property) => {
            const path = 'value.producerCodeOfRecord_Ext.code';

            const values = _.orderBy(
                orgProducerCodes || [],
                'producerContactLastName_ML',
                'asc'
            ).map((producerCode) => {
                const firstName = producerCode.producerContactFirstName_ML || '';
                const lastName = producerCode.producerContactLastName_ML || '';
                const fullName = firstName?`${firstName}, ${lastName}`:lastName;

                return {
                    code: producerCode.code,
                    name: `${fullName} - ${producerCode.code}`
                }
            })


            const onPORChange = (value) => {
                const selectedProducer =
                    orgProducerCodes.find(
                        (pc) => pc.code === value
                    );

                writeSubmissionValue(
                    selectedProducer,
                    'value.producerCodeOfRecord_Ext',
                    submission,
                    index
                );

                setProducerCodeOfRecord_Ext(selectedProducer?.code)

                refreshData();
            };

            return (
                <DropdownSelectField
                    id={`${property.id}_${index}`}
                    alwaysShowPlaceholder
                    availableValues={values}
                    value={_.get(submission, path)}
                    searchable
                    onValueChange={onPORChange}
                    label="Producer Of Record"
                    hideLabel
                />
            );
        },
        [orgProducerCodes, refreshData]
    );

    const getProducerCodeCell = useCallback((submission, index, property) => {
        const path = 'producerCode.value';

        const createProducerEligibilityRequest = (producerCode) => {
            return {
                state: submission.value.state,
                producerCodeCode: producerCode,
                policyStatus: 'New',
                skipGroupEligibilityCheck : false
            };
        };

        const getProducerCodeType = (producerCodeCode) => {
            const selectedProducerCode = currentUser.producerCodes_ML.find((pCode) => pCode.code === producerCodeCode);
            return selectedProducerCode?.producerType_ML;
        };

        const handleEligibilityError = (data) => {
            const defaultReason = translator(messages.selectDiffProducerCode);
            const reasonToShow = data.nonEligibleReason ? data.nonEligibleReason : defaultReason;
            addError('producerEligibility', reasonToShow);

            writeSubmissionValue(undefined, 'value.producerCode', submission, index);
        };

        const requestProducerEligibility = (producerCode) => {
            removeError('producerEligibility');
            const req = createProducerEligibilityRequest(producerCode);
            const promise = MLProducerEligibilityService.isProducerCodeEligible(req, authHeader);

            showProgressDialog(platformMessages.checkingProducerCodeEligibility, promise);

            promise.then((data) => {
                if (!data.isEligible || !_.isUndefined(data.nonEligibleReason)) {
                    handleEligibilityError(data);
                }
                else if(data.isEligible && req.producerCodeCode !== data.producerCodeCode){
                    writeSubmissionValue(data.producerCodeCode, path, submission, index);
                    writeSubmissionValue(true, 'value.producerAutoUpdated_Ext', submission, index);
                    setIsProducerCodeChangedAutomatically(true)
                }
                else if(data.isEligible && req.producerCodeCode === data.producerCodeCode){
                    writeSubmissionValue(false, 'value.producerAutoUpdated_Ext', submission, index);
                    setIsProducerCodeChangedAutomatically(false)
                }
            });
            promise.catch((error) => {
                // eslint-disable-next-line no-console
                console.error(error);
                handleEligibilityError(error);
            });
        };

        const onProducerCodeChange = (value) => {

            if (!value) {
                return;
            }

            if (MLUserTypes.IA) {
                const selectedProducerCode = currentUser.producerCodes_ML.find((pCode) => pCode.code === value);

                if (selectedProducerCode != null && selectedProducerCode?.strategicPartnershipIndicator != null && selectedProducerCode?.strategicPartnershipIndicator?.toLowerCase() === "y") {
                    setSelectedOrg(selectedProducerCode)
                }
            }         
          
            writeSubmissionValue(value, path, submission, index);

            updateProducerCodeProducerType(getProducerCodeType(value));
            requestProducerEligibility(value);
            getAvailableProducts(submission);
        };

        const getProducerCodeDisplayName = (producerCode) => {
            const displayName = (strings, lastName, firstName, code) => {
                const retval = [];
                const comma = strings[1];
                const hyphen = strings[2];

                if (lastName) {
                    retval.push(_.capitalize(lastName));
                }

                if (firstName) {
                    if (lastName) {
                        retval.push(`${comma} `);
                    }
                    retval.push(_.capitalize(firstName));
                }
                if (lastName) {
                    retval.push(` ${hyphen} `);
                }
                retval.push(code);
                return retval.join('');
            };
            return displayName`${producerCode.producerContactLastName_ML}, ${producerCode.producerContactFirstName_ML} - ${producerCode.code}`;
        };

        const getProducerCodeValues = () => {
                const producerCodes = currentUser?.producerCodes_ML
                
            return _.orderBy(producerCodes, 'producerContactLastName_ML', 'asc')
                .map((producerCode) => {
                    return {
                        code: producerCode.code,
                        name: getProducerCodeDisplayName(producerCode)
                    };
                });
        };

        const getDefaultValue = () => {
            if (!isInitialProducerCodeValidated.current[index]?.isvalidated) {
                const value = _.get(submission, path)
                onProducerCodeChange(value);
                isInitialProducerCodeValidated.current = [...isInitialProducerCodeValidated.current,{index:index,isvalidated : true}]
                return _.get(submission, path)
            }
        }

        if (hasAvailableProducerCodes() && submission.value.state) {
            const label = translator(messages.producerCode);
            const hideLabel = true;
            return (
                <DropdownSelectField
                    id={`${property.id}_${index}`}
                    alwaysShowPlaceholder
                    availableValues={getProducerCodeValues()}
                    onValueChange={onProducerCodeChange}
                    value={_.get(submission, path)}
                    defaultValue = {getDefaultValue()}
                    searchable
                    label={label}
                    hideLabel={hideLabel}
                />
            );
        }

        return (
            <span>-</span>
        );
    }, [addError, authHeader, currentUser, removeError, translator, writeSubmissionValue, isAnotherOrg ,isInitialProducerCodeValidated]);

    const onPostalCodeOrEffDateChange = useCallback((value, path, submission, index) => {
        const newSubmission = writeSubmissionValue(value, path, submission, index);
        if (newSubmission.postalCode_ML.aspects.valid && newSubmission.effectiveDate.aspects.valid) {
            getAvailableProducts(newSubmission);
        }
    }, [getAvailableProducts, writeSubmissionValue]);

    const getEffectiveDateCell = useCallback((submission, index, property) => {
        const path = 'effectiveDate.value';
        const label = translator(messages.effectiveDate);
        const hideLabel =  true;

        return (
            <DateField
                id={`${property.id}_${index}`}
                displayFormat="short"
                value={_.get(submission, path)}
                onValueChange={(value) => onPostalCodeOrEffDateChange(value, path, submission, index)}
                label={label}
                hideLabel={hideLabel}
            />
        );
    }, [onPostalCodeOrEffDateChange, translator]);

    const getZipCodeCell = useCallback((submission, index, property) => {
        const path = 'postalCode_ML.value';
        const validationMessagesPath = 'postalCode_ML.aspects.validationMessages';
        const label = translator(messages.zipCode);
        const hideLabel = true;

        return (
            <InputField
                id={`${property.id}_${index}`}
                value={_.get(submission, path)}
                onValueChange={(value) => onPostalCodeOrEffDateChange(value, path, submission, index)}
                showErrors
                required
                validationMessages={_.get(submission, validationMessagesPath, [])}
                label={label}
                hideLabel={hideLabel}
            />
        );
    }, [onPostalCodeOrEffDateChange, translator]);

    const isLandlordProduct = (selecedProductCode) => {
        return MLProductCodeUtil.isHomeOwnersPartialTypeLandlordHome(selecedProductCode)
            || MLProductCodeUtil.isHomeOwnersPartialTypeLandlordCondo(selecedProductCode);
    };

    const isModernProductPersonalAuto = useCallback((submission, selectedProductCode) => {
        const { state } = submission?.value;
        return MLProductCodeUtil.isPersonalAuto(selectedProductCode)
            && newProductStates?.includes(state)
    }, [newProductStates]);

    const isModernProductHome = useCallback((submission, selectedProductCode) => {
        const { state } = submission?.value;
        return MLProductCodeUtil.isHomeOwnersPartialTypeHome(selectedProductCode)
            && (homeNewProductStates?.includes(state) || isNewProduct?.includes(state))
    }, [homeNewProductStates, isNewProduct]);

    const isModernProductCondo = useCallback((submission, selectedProductCode) => {
        const { state } = submission?.value;
        return MLProductCodeUtil.isHomeOwnersPartialTypeCondo(selectedProductCode)
            && (homeNewProductStates?.includes(state) || isNewProduct?.includes(state))
    }, [homeNewProductStates, isNewProduct]);

    const isModernProductRenters = useCallback((submission, selectedProductCode) => {
        const { state } = submission?.value;
        return MLProductCodeUtil.isHomeOwnersPartialTypeRental(selectedProductCode)
            && (homeNewProductStates?.includes(state) || isNewProduct?.includes(state))
    }, [homeNewProductStates, isNewProduct]);

    const isModernProductLLH = useCallback((submission, selectedProductCode) => {
        const { state } = submission?.value;
        return MLProductCodeUtil.isHomeOwnersPartialTypeLandlordHome(selectedProductCode)
            && (homeNewProductStates?.includes(state) || isNewProduct?.includes(state))
    }, [homeNewProductStates, isNewProduct]);

    const isModernProductLLC = useCallback((submission, selectedProductCode) => {
        const { state } = submission?.value;
        return MLProductCodeUtil.isHomeOwnersPartialTypeLandlordCondo(selectedProductCode)
            && (homeNewProductStates?.includes(state) || isNewProduct?.includes(state))
    }, [homeNewProductStates, isNewProduct]);

    const getProductCell = useCallback((submission, index, property) => {
        const path = 'productCode.value';

        const getProductAvailableValues = () => {
            const { availableProducts } = submission;
            return availableProducts.map((product) => {
                return {
                    code: product.productCode,
                    name: getPolicyTypeName(product.productCode)
                };
            });
        };

        const onProductChange = (selectedProductCode) => {
            const newSubmission = writeSubmissionValue(selectedProductCode, path, submission, index);
            if (!_.isUndefined(selectedProductCode) && isModernProductPersonalAuto(newSubmission, selectedProductCode)) {
                const firstAvailableOffering = getFirstAvailableOfferingForProduct('PersonalAuto_ModernProduct');
                writeSubmissionValue(firstAvailableOffering && firstAvailableOffering.code, 'offeringCode_ML.value', newSubmission, index);
            }
            else if (!_.isUndefined(selectedProductCode) && isModernProductHome(newSubmission, selectedProductCode) && !isAnotherOrg && userType === MLUserTypes.GCS_SALES) {
                const firstAvailableOffering = getFirstAvailableOfferingForProduct('HOP_ModernProduct');
                writeSubmissionValue(firstAvailableOffering && firstAvailableOffering.code, 'offeringCode_ML.value', newSubmission, index);
            }
            else if (!_.isUndefined(selectedProductCode) && isModernProductCondo(newSubmission, selectedProductCode) && !isAnotherOrg && userType === MLUserTypes.GCS_SALES) {
                const firstAvailableOffering = getFirstAvailableOfferingForProduct('HOPCondo_ModernProduct');
                writeSubmissionValue(firstAvailableOffering && firstAvailableOffering.code, 'offeringCode_ML.value', newSubmission, index);
            }
            else if (!_.isUndefined(selectedProductCode) && isModernProductRenters(newSubmission, selectedProductCode) && !isAnotherOrg && userType === MLUserTypes.GCS_SALES) {
                const firstAvailableOffering = getFirstAvailableOfferingForProduct('HOPRenters_ModernProduct');
                writeSubmissionValue(firstAvailableOffering && firstAvailableOffering.code, 'offeringCode_ML.value', newSubmission, index);
            }
            else if (!_.isUndefined(selectedProductCode) && isModernProductLLH(newSubmission, selectedProductCode) && !isAnotherOrg && userType === MLUserTypes.GCS_SALES) {
                const firstAvailableOffering = getFirstAvailableOfferingForProduct('LLH_ModernProduct');
                writeSubmissionValue(firstAvailableOffering && firstAvailableOffering.code, 'offeringCode_ML.value', newSubmission, index);
            }
            else if (!_.isUndefined(selectedProductCode) && isModernProductLLC(newSubmission, selectedProductCode) && !isAnotherOrg && userType === MLUserTypes.GCS_SALES) {
                const firstAvailableOffering = getFirstAvailableOfferingForProduct('LLC_ModernProduct');
                writeSubmissionValue(firstAvailableOffering && firstAvailableOffering.code, 'offeringCode_ML.value', newSubmission, index);
            }
            else if (!_.isUndefined(selectedProductCode) && isLandlordProduct(selectedProductCode) && !isModernProductLLC(newSubmission, selectedProductCode) && !isModernProductLLH(newSubmission, selectedProductCode)) {
                const firstAvailableOffering = getFirstAvailableOfferingForProduct(selectedProductCode);
                writeSubmissionValue(firstAvailableOffering && firstAvailableOffering.code, 'offeringCode_ML.value', newSubmission, index);
            }
             else {
                writeSubmissionValue(null, 'offeringCode_ML.value', newSubmission, index);
            }
        };

        if (hasAvailableProducts(submission)) {
            const label = translator(messages.product);
            const hideLabel = true;

            return (
                <DropdownSelectField
                    id={`${property.id}_${index}`}
                    alwaysShowPlaceholder
                    availableValues={getProductAvailableValues()}
                    onValueChange={onProductChange}
                    value={_.get(submission, path)}
                    searchable
                    label={label}
                    hideLabel={hideLabel}
                />
            );
        }
        return (
            <span>-</span>
        );
    }, [getFirstAvailableOfferingForProduct, getPolicyTypeName, isModernProductPersonalAuto, translator, writeSubmissionValue, isModernProductHome, isModernProductCondo, isModernProductRenters, isModernProductLLH, isModernProductLLC]);

    const hasAvailableOfferings = useCallback((productCode) => {
        refreshOfferingsWithUserType(userType);
        const offeringsForProduct = getAvailableOfferingsForProduct(productCode);
        return offeringsForProduct && offeringsForProduct.length > 0;
    }, [getAvailableOfferingsForProduct]);

    const getOfferingCell = useCallback((submission, index, property) => {
        const path = 'offeringCode_ML.value';
        const { productCode, state } = submission.value;

        const getAvailableOfferings = () => {
            // will only get called when offerings are available for IA or PCS or MetGA
            // thus no need for null checks here
            refreshOfferingsWithUserType(userType);
            if(newProductStates?.includes(state) && isModernProductPersonalAuto(submission, productCode)){
                return getAvailableOfferingsForProduct('PersonalAuto_ModernProduct');
            }
            else  if((homeNewProductStates?.includes(state) || isNewProduct?.includes(state)) && isModernProductHome(submission, productCode)){
                return getAvailableOfferingsForProduct('HOP_ModernProduct');
            }
            else  if((homeNewProductStates?.includes(state) || isNewProduct?.includes(state)) && isModernProductCondo(submission, productCode)){
                return getAvailableOfferingsForProduct('HOPCondo_ModernProduct');
            }
            else  if((homeNewProductStates?.includes(state) || isNewProduct?.includes(state)) && isModernProductRenters(submission, productCode)){
                return getAvailableOfferingsForProduct('HOPRenters_ModernProduct');
            }
            else  if((homeNewProductStates?.includes(state) || isNewProduct?.includes(state)) && isModernProductLLH(submission, productCode)){
                return getAvailableOfferingsForProduct('LLH_ModernProduct');
            }
            else  if((homeNewProductStates?.includes(state) || isNewProduct?.includes(state)) && isModernProductLLC(submission, productCode)){
                return getAvailableOfferingsForProduct('LLC_ModernProduct');
            }
            return getAvailableOfferingsForProduct(productCode);
        };

        const onOfferingChange = (value) => {
            writeSubmissionValue(value, path, submission, index);
        };

        if (hasAvailableOfferings(productCode) && (!isLandlordProduct(productCode) || isModernProductLLH(submission, productCode) || isModernProductLLC(submission, productCode)) && !isModernProductPersonalAuto(submission, productCode)) {
            const label = translator(messages.offering);
            const hideLabel = true;

            return (
                <DropdownSelectField
                    id={`${property.id}_${index}`}
                    alwaysShowPlaceholder
                    availableValues={getAvailableOfferings()}
                    onValueChange={onOfferingChange}
                    value={_.get(submission, path)}
                    searchable
                    label={label}
                    hideLabel={hideLabel}
                    />
            );
        }
        return (
            <span>{submission.value.productCode === 'PersonalUmbrella' ? 'N/A' : '-'}</span>
        );
    }, [getAvailableOfferingsForProduct, hasAvailableOfferings, writeSubmissionValue]);

    const getQuoteCell = () => {
        return <span aria-label={translator(messages.quote)} tabIndex={0}>
        {translator(messages.quoteNew)}
      </span>      
    };

    const areSubmissionsValid = useCallback((subs) => {
        return subs.every((sub) => sub.aspects.valid && sub.aspects.subtreeValid);
    }, []);

    const doesItemExistInBundle = (item) => {
        return !!item.value.included;
    };

    const getAllIncludedSubmissions = useCallback(() => {
        return [...newSubmissions, ...savedQuotes, ...existingPolicies].filter((item) => doesItemExistInBundle(item));
    }, [existingPolicies, newSubmissions, savedQuotes]);

    const canAddNewSubmissionToQuote = useCallback(() => {
        return areSubmissionsValid(getAllIncludedSubmissions());
    }, [areSubmissionsValid, getAllIncludedSubmissions]);

    const bundleHasMoreThanOneUmbrellaPolicy = useCallback(() => {
        let pupIncludedCount = 0;

        getAllIncludedSubmissions().forEach((sub) => {
            if (sub.value.productCode === "PersonalUmbrella" && sub.value.included) {
                pupIncludedCount += 1;
            }
        });

        return pupIncludedCount >= 2;
    }, [getAllIncludedSubmissions]);

    const removeUmbrellaBundleError = useCallback(() => {
        const currErrors = [...errorsRef.current];
        const idx = currErrors.findIndex((error) => error.key === BUNDLE_ERROR_MSG_KEY && error.message === BUNDLE_UMB_ERROR_MSG);
        if (idx > -1) {
            setErrors(currErrors.filter((error) => error.key !== BUNDLE_ERROR_MSG_KEY && error.message !== BUNDLE_UMB_ERROR_MSG));
        }
    }, []);

    const getIncludeCell = useCallback((submission, index, property) => {
        const path = 'value.included';

        const isEditingSubmission = () => {
            return (submission.value.tempId === newSubmissions.length - 1) && submission.value.included;
        };

        const toggleBundleSelection = () => {
            if (submission.value.bookRollIndicator !== 'No') {
                const tempBookRollQuotes = [...bookRollQuotes];
                tempBookRollQuotes.forEach((quote) => {
                    _.set(quote, 'value.included', !quote.value.included);
                });
                updateBookRollQuotes(tempBookRollQuotes);
            } else {
                writeSubmissionValue(!submission.value.included, path, submission, index);
                if (!bundleHasMoreThanOneUmbrellaPolicy()) {
                    removeUmbrellaBundleError();
                }
            }
        };

        const removeSubmission = () => {
            const idx = newSubmissions.findIndex((quote) => quote.value.tempId === submission.value.tempId);
            if (idx > -1) {
                updateNewSubmissions(newSubmissions.filter((quote) => quote.value.tempId !== submission.value.tempId));
            }
        };

        if (!isEditingSubmission(submission) || canAddNewSubmissionToQuote()) {
            const label = translator(messages.include);
            const hideLabel = true;
            
            return (
                <CheckboxField
                    id={`${property.id}_${index}`}
                    name={`${property.id}_${index}`}
                    value={_.get(submission, path)}
                    onValueChange={toggleBundleSelection}
                    label={label}
                    hideLabel={hideLabel}
                />
            );
        }
        if (isEditingSubmission(submission) && !canAddNewSubmissionToQuote() && newSubmissions.length > 1) {
            return (
                <Button
                    id={`${property.id}_${index}`}
                    className={styles['remove-button-link']}
                    onClick={removeSubmission}
                >
                    {translator(messages.removeQuote)}
                </Button>
            );
        }
        if (isEditingSubmission(submission) && !canAddNewSubmissionToQuote() && newSubmissions.length === 1) {
            return '-';
        }
    }, [bookRollQuotes, canAddNewSubmissionToQuote, newSubmissions, translator, writeSubmissionValue]);

    const getSavedQuoteProducerCodeCell = useCallback((quote) => {
        return `${_.get(quote, 'value.producerContactLastName_ML', '')}, ${_.get(quote, 'value.producerContactFirstName_ML', '')} - ${quote.producerCode.value}`;
    }, []);

    const getEditingSubmission = useCallback(() => {
        return (newSubmissions.length > 0) ? newSubmissions[newSubmissions.length - 1] : undefined;
    }, [newSubmissions]);

    const getBundledSubmissions = useCallback(() => {
        const bundledSubmissions = getAllIncludedSubmissions();
        const editingSubmission = getEditingSubmission();

        if (editingSubmission && !(editingSubmission.aspects.valid && editingSubmission.aspects.subtreeValid)) {
            const idx = bundledSubmissions.findIndex((sub) => sub.tempId === editingSubmission.tempId);
            bundledSubmissions.splice(idx, 1);
        }
        return bundledSubmissions;
    }, [getAllIncludedSubmissions, getEditingSubmission]);

    const getSavedQuoteEffectiveDateCell = useCallback((quote, index, property) => {
        const path = 'effectiveDate.value';

        const shouldDisableIncludeOption = () => {
            const selectedQuotes = getBundledSubmissions();
            // if quote is non book roll and no bookrolls exist in selected quotes.. allow include
            if (quote.value.bookRollIndicator === 'No') {
                if (selectedQuotes.every((sub) => sub.value.bookRollIndicator === 'No')) {
                    return false;
                }
                return !quote.value.included;
            }

            return selectedQuotes.some((sub) => sub.value.bookRollIndicator === 'No');
        };

        const shouldExcludeFromBundle = () => {
            return shouldDisableIncludeOption(quote) && !quote.value.included;
        };

        return (
            <DateField
                id={`${property.id}_${index}`}
                displayFormat="short"
                value={_.get(quote, path)}
                disabled={shouldExcludeFromBundle(quote) || quote.value.bookRollIndicator !== 'No'}
                onValueChange={(value) => writeSavedQuotesValue(value, path, quote, index)}
            />
        );
    }, [getBundledSubmissions, writeSavedQuotesValue]);

    const getSavedQuoteZipCodeCell = useCallback((quote) => {
        return quote.postalCode_ML.value;
    }, []);

    const getSavedQuoteProductCell = useCallback((quote) => {
        return getPolicyTypeName(quote.productCode.value);
    }, [getPolicyTypeName]);

    const getSavedQuoteOfferingCell = useCallback((quote) => {
        return quote.offeringCode_ML.value && (!isLandlordProduct(quote.productCode.value) || 
        isModernProductLLC(quote,quote?.productCode?.value) || isModernProductLLH(quote,quote?.productCode?.value)) ? quote.offeringCode_ML.value : 'N/A';
    }, []);

    const getSavedQuoteCovProtectLevelCell = useCallback((quote,submission) => {
  
        if (isModernProductPersonalAuto(quote,quote?.productCode?.value) || (isLandlordProduct(quote?.productCode?.value) &&
         !isModernProductLLC(quote,quote?.productCode?.value) && !isModernProductLLH(quote,quote?.productCode?.value)) ) {

            return 'N/A';
        } 
        return quote.coveragePackageLevel_Ext && quote.coveragePackageLevel_Ext.value ? quote.coveragePackageLevel_Ext.value : quote.offeringCode_ML.value;
        
    }, []);

    const displayCompRaterQuote = (quote) => {
        return quote.isCompRaterRequest && quote.totalPremium.amount === 0;
    };

    const getSavedQuoteQuoteCell = useCallback((quote) => {
        const formatAmountString = (amount) => {
            try {
                return intl.formatNumber(amount.amount, { style: 'currency', currency: amount.currency });
            } catch (e) {
                return '';
            }
        };

        const getPremiumText = (quoteValue) => {
            const totalPremium = displayCompRaterQuote(quoteValue) ? quoteValue.compRaterPremium : quoteValue.totalPremium;
            const termType = displayCompRaterQuote(quoteValue) ? quoteValue.compRaterTermType : quoteValue.termType;
            if (_.isUndefined(totalPremium)) {
                return translator(messages.noValue);
            };

            switch (termType) {
                case 'Annual':
                    return totalPremium.amount > 0 ? translator(messages.premiumPerYear, { totalPremium: formatAmountString(totalPremium) })
                        : translator(messages.noValuePerYear);
                case 'HalfYear':
                    return totalPremium.amount > 0 ? translator(messages.premiumPerHalfYear, { totalPremium: formatAmountString(totalPremium) })
                        : translator(messages.noValuePerHalfYear);
                default:
                    return totalPremium.amount > 0 ? formatAmountString(totalPremium) : translator(messages.noValue);
            }
        };

        return (
            <>
                <div>
                    {quote.jobNumber.value}
                    {(quote.value.bookRollIndicator === 'With Rate Capping' || quote.value.bookRollIndicator === 'Without Rate Capping')
                        && (
                            <i className="ml-pill ml-pill-warning vertical-align-middle" title={quote.value.bookRollIndicator === 'With Rate Capping' ? translator(messages.rateCapped) : translator(messages.nonRateCapped) }>
                                {quote.value.bookRollIndicator === 'With Rate Capping' && translator(messages.rateCappedShortForm)}
                                {quote.value.bookRollIndicator === 'Without Rate Capping' && translator(messages.nonRateCappedShortForm)}
                            </i>
                        )
                    }
                </div>
                <strong>{getPremiumText(quote.value)}</strong>
            </>
        );
    }, [intl, translator]);

    const getSavedQuoteCompRaterCell = useCallback((quote) => {
        if (displayCompRaterQuote(quote.value)) {
            return (
                <span title={translator(messages.originalCRQuote)} className='ml-pill ml-pill-default display-inline-block vertical-align-middle'>
                    {translator(messages.compRaterCR)}
                </span>
            )
        }
    }, [translator]);

    const getSavedQuoteIncludeCell = useCallback((quote, index, property) => {
        const path = 'value.included';

        const shouldDisableIncludeOption = () => {
            const selectedQuotes = getBundledSubmissions();
            // if quote is non book roll and no bookrolls exist in selected quotes.. allow include
            if (quote.value.bookRollIndicator === 'No') {
                if (selectedQuotes.every((sub) => sub.value.bookRollIndicator === 'No')) {
                    return false;
                }
                return !quote.value.included;
            }

            return selectedQuotes.some((sub) => sub.value.bookRollIndicator === 'No');
        };

        const toggleBundleSelection = () => {
            if (quote.value.bookRollIndicator !== 'No') {
                const tempBookRollQuotes = [...bookRollQuotes];
                tempBookRollQuotes.forEach((bookRollQuote) => {
                    _.set(bookRollQuote, path, !bookRollQuote.value.included);
                });
                updateBookRollQuotes(tempBookRollQuotes);
            } else {
                writeSavedQuotesValue(!quote.value.included, path, quote, index);
                if (!bundleHasMoreThanOneUmbrellaPolicy()) {
                    removeUmbrellaBundleError();
                }
            }
        };

        return (
            <CheckboxField
                id={`${property.id}_${index}`}
                name={`${property.id}_${index}`}
                value={_.get(quote, path)}
                onValueChange={toggleBundleSelection}
                disabled={shouldDisableIncludeOption()}
            />
        );
    }, [bookRollQuotes, getBundledSubmissions, writeSavedQuotesValue]);

    const addNewSubmissionToQuote = () => {
        createNewSubmission(userType);
        MLTagManagerService.sendLinkClickEvent('QuotesStart_AddAnother');
    };

    const canStartQuote = useCallback(() => {
        const selectedSubmissions = getBundledSubmissions();

        // If no quotes are included -> false
        if (selectedSubmissions.length < 1) {
            return false;
        }

        if (selectedSubmissions.length > 5) {

            return false;
        }

        // Only the editing submission involved, consider just its validity
        if (!areSubmissionsValid(selectedSubmissions)) {
            return false;
        }

        if (errors.length > 0) {
            return false;
        }

        if (isAnotherOrg && !selectedOrg?.code) {
            return false;
        }


        return true;
    }, [areSubmissionsValid, errors.length, getBundledSubmissions,isAnotherOrg,selectedOrg?.code]);

    const resetErrors = () => {
        errors.splice(0, errors.length);
    };

    const hasExistingSavedQuotes = () => {
        return savedQuotes && savedQuotes.length > 0;
    };

    const hasExistingPolicies = () => {
        return (existingPolicies && existingPolicies.length > 0) || (account.policySummaries && account.policySummaries.length > 0);
    };

    const getNewSubmissionsAndSavedQuotes = () => {
        return [...newSubmissions, ...savedQuotes];
    };

    const isPastEffectiveDate = () => {
        return getNewSubmissionsAndSavedQuotes().some((s) => moment(s.effectiveDate.value).isBefore(moment(), 'day'));
    };

     
    const bundleQuotelimit = () => {
        if (getBundledSubmissions().length > 5) {
            return true;
        }

        return false;
    };

    const hasExistingBookrollQuotes = () => {
        return bookRollQuotes && bookRollQuotes.length > 0;
    };

    const isBookrollQuote = (quote) => {
        return quote.bookRollIndicator === 'With Rate Capping' || quote.bookRollIndicator === 'Without Rate Capping';
    };

    const isBookrollQuoteSelected = () => {
        return hasExistingBookrollQuotes() && bookRollQuotes.some((quote) => quote.value.included);
    };

    const getBookrollMessaging = () => {
        if (getBundledSubmissions().length < 1) {
            return translator(messages.bundledBookrollWarningMsg);
        }
        return isBookrollQuoteSelected() ? translator(messages.selectedBookrollWarningMsg) : translator(messages.nonSelectedBookrollWarningMsg);
    };
    
    const hasCompRaterQuote = useCallback(() => {
        return savedQuotes.some((elt) => displayCompRaterQuote(elt.value));
    }, [savedQuotes]);

    const getColumnsProposition = useCallback(() => {
        return hasCompRaterQuote() ? [2.2, 1.7, 1.5, 1.3, 1.3, 0.8, 0.2, 0.3] : [2.2, 1.7, 1.5, 1.3, 1.3, 0.8, 0.3];
    }, [hasCompRaterQuote]);
     
    const onChangeAnotherOrganization = useCallback((value) => {
        const checked =
            value?.value ??
            value?.checked ??
            value;

        setIsAnotherOrg(!!checked);

        if (!checked) {
            setSelectedOrg(null);
            setOrgProducerCodes([]);
            setReferralAgentId(null);
        }
    }, []);

const getProducerCodesByOrg = async (orgCode) => {
    const producerCodes = await OrganizationService.getProducerCodeForOrganization(
        { publicID: orgCode },
        authHeader
    );

    setOrgProducerCodes(producerCodes);
    const defaultProducer = producerCodes?.[0];
    setProducerCodeOfRecord_Ext(defaultProducer?.code)
    if (defaultProducer) {
        const editingSubmission =
            newSubmissions[newSubmissions.length - 1];

        if (editingSubmission) {
            _.set(
                editingSubmission,
                'value.producerCodeOfRecord_Ext',
                defaultProducer
            );

            refreshData();
        }
    }
};

const renderOrganizationSPLabel = (org) => (
    <div
        style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
        }}
    >
        <span>{org.displayName}</span>

        {org.strategicPartnershipIndicator === STRATEGIC_PARTNER && (
            <span
                style={{
                    backgroundColor: '#e0e0e0',
                    color: '#333333',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    fontWeight: '500',
                    whiteSpace: 'nowrap'
                }}
            >
                Strategic Partner
            </span>
        )}
    </div>
);

const getAllOrganisation = async () => {
    try {
        const response = await OrganizationService.getAvailableOrganizations(authHeader);
        const allOrganisationValue = response
       .filter(value => value.strategicPartnershipIndicator === STRATEGIC_PARTNER)
        .map((value,index) => ({
            code: value.publicID,
            displayName: value.displayName,
            name: renderOrganizationSPLabel(value),
            strategicPartnershipIndicator: value.strategicPartnershipIndicator
        }))

        return allOrganisationValue;

    } catch (error) {
        console.error("Error fetching organizations:", error);
        return [];
    }
};

    useEffect(() => {
        const loadOrganizations = async () => {
            const data = await getAllOrganisation();
            setOrgList(data);
        };

        loadOrganizations();

    }, []);

const onOrganizationChange =async (value) => {

    if (!value) {
        return;
    }

    const selectedCode = value;

    const selectedOrgObj = orgList.find(
        (org) => org.code === selectedCode
    );

    setSelectedOrg(selectedOrgObj);

    await getProducerCodesByOrg(selectedCode);

    if (selectedOrgObj != null && selectedOrgObj.strategicPartnershipIndicator === STRATEGIC_PARTNER) {
        setReferralAgentId(currentUser?.primaryProducerCode_ML?.code)
    }
    else {
        setReferralAgentId(null)
    }
    };


    const isNewModernProduct = () => {
        const state = newSubmissions?.[0]?.value?.state;
        return npStates?.includes(state) ?? false;
    };

    const overrides = {
        producerOfRecord: {
            visible: userType === MLUserTypes.GCS_SALES && isAnotherOrg           
        },
        anotherOrganization: {
            visible: userType === MLUserTypes.GCS_SALES && isNewAccount && isNewModernProduct() && producerCodeSecurity !== true,
            value: isAnotherOrg,
            onValueChange: onChangeAnotherOrganization
        },
        organizationSearch: {
            visible: isAnotherOrg,
            options: orgList,
            value: selectedOrg?.code,
            onChange: onOrganizationChange,
            placeholder: 'Search organization'
        },
        startQuoteTable: {
            data: newSubmissions,
            columnsProportion: getColumnsProposition()
        },
        producerCode: {
            visible: isMetGAorIAorPCSAgent()
        },
        offering: {
            visible: isMetGAorIAorPCSAgent() ||  (isAnotherOrg && MLUserTypes.GCS_SALES)
        },
        startQuoteButton: {
            disabled: !canStartQuote(),
            content: getBundledSubmissions().length > 1 ? translator(messages.quoteBundleButton) : translator(messages.startQuoteButton)
        },
        addNewSubmissionToQuoteContainer: {
            visible: canAddNewSubmissionToQuote()
        },
        addNewSubmissionButton: {
            disabled: !canAddNewSubmissionToQuote(),
            onClick: addNewSubmissionToQuote
        },
        addAnotherText: {
            visible: newSubmissions.length === 1
        },
        savedQuotesTableContainer: {
            visible: hasExistingSavedQuotes(),
        },
        savedQuotesTable: {
            data: savedQuotes,
            columnsProportion: getColumnsProposition()
        },
        savedQuoteProducerCode: {
            visible: isMetGAorIAorPCSAgent()
        },
        savedQuoteOffering: {
            visible: isMetGAorIAorPCSAgent()
        },
        savedQuotesContainer: {
            visible: hasExistingSavedQuotes()
        },
        savedQuotesTitle: {
            className: canAddNewSubmissionToQuote() ? 'savedQuotesTitle savedQuotesPadding' : 'savedQuotesTitle'
        },
        savedQuoteCompRater: {
            visible: hasCompRaterQuote()
        },
        compRater: {
            visible: hasCompRaterQuote()
        },
        pastEffectiveDateWarning: {
            visible: isPastEffectiveDate()
        },
        bundleQuotelimitError: {
            visible: bundleQuotelimit()
        },
        existingBookrollQuotesWarning: {
            visible: hasExistingBookrollQuotes()
        },
        existingBookrollQuotesWarningMessage: {
            message: getBookrollMessaging()
        },
        errorsIterable: {
            data: errors
        },
        producerCodeChanged: {
            visible: isProducerCodeChangedAutomatically
        }
    };

    const startQuote = () => {
        resetErrors();

        const selectedSubmissions = getBundledSubmissions();

        if (!areSubmissionsValid(selectedSubmissions)) {
            return false;
        }

        const submissions = _.map(selectedSubmissions, (job) => {
            const submission = _.cloneDeep(job.value);
            if (_.isObject(submission.productCode)) {
                submission.productCode = submission.productCode.publicID;
            }

            if (_.isObject(submission.producerCodeOfRecord_Ext) && isNewModernProduct()) {
                if (isAnotherOrg) {
                    localStorage.setItem("strategicPartnershipInd_Ext", selectedOrg?.strategicPartnershipIndicator || 'N');
                    localStorage.setItem("referralAgentId", referralAgentId);
                    localStorage.setItem("producerCodeOfRecord_Ext", producerCodeOfRecord_Ext);
                }
                else {
                    localStorage.removeItem("strategicPartnershipInd_Ext");
                    localStorage.removeItem("referralAgentId");
                    localStorage.removeItem("producerCodeOfRecord_Ext");
                }
                submission.producerCodeOfRecord_Ext =
                    submission.producerCodeOfRecord_Ext.code;
                submission.strategicPartnershipInd_Ext = true
            }

            submission.coveragePartType_ML = MLProductCodeUtil.isHomeOwnersCoveragePart(submission.productCode)
                ? submission.productCode
                : null;
            submission.productCode = MLProductCodeUtil.isHomeOwnersCoveragePart(submission.productCode)
                ? MLProductCodeUtil.getHomeOwnersCode()
                : submission.productCode;

            if(_.isObject(submission.accountNumber)){
                submission.accountNumber = submission.accountNumber.value;
            }
            if(_.isObject(submission.country)){
                submission.country = submission.country.code;
            }

            return submission;
        });

        const _determineRoute = () => {
            const productsBundle = submissions.map((sub) => MLTagManagerService.getPolicyTypeName(sub.productCode)).join('|');
            const attributes = {
                form: 'Start a Quote',
                product: submissions[0].productCode,
                bundleChoose: productsBundle
            };
            MLTagManagerService.sendEvent('quoteStart', attributes);

            const accountNumber = _.isObject(account.accountNumber) ? account.accountNumber.value : account.accountNumber
            if (history.location.pathname.indexOf('agent-bundle-cart') > -1) {
                MLBundleService.refreshBundleSummary(accountNumber, authHeader);
                if (onSave) {
                    onSave();
                }
                return;
            }

            const agentBundleCartInfo = {
                accountNumber: accountNumber,
                hasExistingSubmissions_ML: hasExistingSavedQuotes() || hasExistingPolicies()
            };
            history.push(`/agent-bundle-cart/${agentBundleCartInfo.accountNumber}`, agentBundleCartInfo);
            if (onSave) {
                onSave();
            }
        }

        if (submissions.length > 1) {
            const newBundlePromise = MLBundleService.startBundle(submissions, authHeader).then(() => {
                const aJobNumber = submissions.find((sub) => sub.jobNumber)?.jobNumber;
                MLStateRolloutService.checkIsCRWizardEligible(aJobNumber, authHeader)
                    .then((isCREligible) => {
                        if(isCREligible) {
                            const hasAnyCompRaterQuote = submissions.some((sub) => sub.isCompRaterRequest);
                            if(hasAnyCompRaterQuote) {
                                const compRaterQuotes = submissions.filter((sub) => sub.isCompRaterRequest === true);
                                const quoteEntryInfo = {
                                    account: compRaterQuotes[0].accountNumber,
                                    quoteID: compRaterQuotes[0].jobNumber
                                };
                                history.push('/quoteentry', quoteEntryInfo);
                                if (onSave) {
                                    onSave();
                                }
                            } else {
                                _determineRoute();
                            }
                        }
                        else {
                            _determineRoute();
                        }
                    });
            }).catch((error) => {
                const errorMessageStringArray = error.baseError.split(' ');
                const errorMessageIndex = errorMessageStringArray.lastIndexOf('ErrorMessage:');
                const errorMessageValue = errorMessageIndex !== -1 ? errorMessageStringArray[errorMessageIndex + 1] : undefined;

                const innerErrorCodeIndex = errorMessageStringArray.lastIndexOf('ErrorCode:');
                const innerErrorCodeValue = innerErrorCodeIndex !== -1 ? errorMessageStringArray[innerErrorCodeIndex + 1] : undefined;
                const innerErrorCodeNumericValue = !_.isUndefined(innerErrorCodeValue) ? parseInt(innerErrorCodeValue, 10) : undefined
                let errorMessage;
                if (error.baseError.lastIndexOf('ErrorMessage:') > -1 && (error.baseError.lastIndexOf('StackTrace_ML:') > -1 || (error.baseError.includes('ERROR-803') || error.baseError.includes('ERROR-805')))) {
                    errorMessage = error.baseError.slice(error.baseError.lastIndexOf('ErrorMessage:'), error.baseError.lastIndexOf('StackTrace_ML:'))
                        .replace("ErrorMessage:","")
                        .replace(errorMessageValue, "")
                        .trim();
                }
                if (innerErrorCodeNumericValue === -31000 && (errorMessage?.includes('ERROR-803') || errorMessage?.includes('ERROR-805'))) {
                    if (errorMessage.indexOf("Messages_ML:") > -1) {
                        errorMessage = errorMessage.slice(0, errorMessage.indexOf("Messages_ML:"));
                    }
                    addError('bundleError', errorMessage.replace("ERROR-803:", "").replace("ERROR-805:", "").trim());
                } else if ( innerErrorCodeNumericValue === -31000 && errorMessage?.includes('This policy is currently locked')){
                    if (errorMessage.indexOf("Messages_ML:") > -1) {
                        errorMessage = errorMessage.slice(errorMessage.indexOf(":")+1)
                    }
                    addError('bundleError', errorMessage.replace("[","").replace("]", "").trim());
                } else {
                    addError('genericError', messages.genericErrorMessage);
                }
            });

            showProgressDialog(platformMessages.loading, newBundlePromise);
        } else if (submissions.length === 1) {
            const initialBundledQuotes = initialSavedQuotes.filter((quote) => quote.value.included === true).map((quote) => quote.jobNumber.value);

            const goToQuoteEntry = () => {
                const nextJob = submissions[0];
                const quoteEntryInfo = {
                    effectiveDate: nextJob.effectiveDate,
                    productCode: nextJob.productCode,
                    producerCode: nextJob.producerCode,
                    stateCode_ML: nextJob.stateCode_ML,
                    postalCode: nextJob.postalCode_ML.substring(0, 5),
                    account: account.value,
                    offeringCode_ML: nextJob.offeringCode_ML,
                    coverageType: nextJob.coveragePartType_ML,
                    /**
                     * Will only exist if the next job was added to the bundle
                     * from an existing saved quote.
                     */
                    quoteID: nextJob.jobNumber,
                    hasExistingSubmissions_ML: hasExistingSavedQuotes() || hasExistingPolicies(),
                    isProducerCodeChangedAutomatically: isProducerCodeChangedAutomatically
                };

                const attributes = {
                    form: 'Start a Quote',
                    product: nextJob.productCode
                };
                MLTagManagerService.sendEvent('quoteStart', attributes);

                if (isAnotherOrg) {
                    localStorage.setItem("strategicPartnershipInd_Ext", selectedOrg?.strategicPartnershipIndicator || 'N');
                    localStorage.setItem("referralAgentId", referralAgentId);
                    localStorage.setItem("producerCodeOfRecord_Ext", producerCodeOfRecord_Ext);
                }
                else {
                    localStorage.removeItem("strategicPartnershipInd_Ext");
                    localStorage.removeItem("referralAgentId");
                    localStorage.removeItem("producerCodeOfRecord_Ext");
                }

                history.push('/quoteentry', quoteEntryInfo);
                if (onSave) {
                    onSave();
                }
            };

            const openQuoteIfApplicable = (job) => {
                if (isBookrollQuote(job) || job.isAlaska7DayQuote) {
                    if (job.totalPremium && job.totalPremium.amount > 0) {
                        goToQuoteEntry();
                    } else {
                        const modalTitle = translator(messages.quoteNotComplete);
                        const modalMsg = translator(messages.contactBookManager);
                        showErrorModal(modalTitle, modalMsg);
                    }
                } else {
                    goToQuoteEntry();
                }
            };

            if (initialBundledQuotes.length > 0) {
                MLBundleService.removeJobsFromBundle(initialBundledQuotes, authHeader).then(() => {
                    openQuoteIfApplicable(submissions[0]);
                }).catch(() => {
                    addError('genericError', messages.genericErrorMessage);
                });
            } else {
                openQuoteIfApplicable(submissions[0]);
            }
        }
    };

    const resolvers = {
          resolveClassNameMap: styles,
        resolveComponentMap: {
            mLOrganizationTypeaheadSearch: MLOrganizationTypeaheadSearch
        },
        resolveCallbackMap: {
            onStartQuote: startQuote,
            onCancel,  
            getProducerCodeCell,
            getProducerOfRecordCell, 
            getEffectiveDateCell,
            getZipCodeCell,
            getProductCell,
            getOfferingCell,
            getQuoteCell,
            getIncludeCell,
            getSavedQuoteProducerCodeCell,
            getSavedQuoteEffectiveDateCell,
            getSavedQuoteZipCodeCell,
            getSavedQuoteProductCell,
            getSavedQuoteOfferingCell,
            getSavedQuoteCovProtectLevelCell,
            getSavedQuoteQuoteCell,
            getSavedQuoteIncludeCell,
            getSavedQuoteCompRaterCell
        }
    };

    return (
    <ViewModelForm
    uiProps={metadata.componentContent}
    classNameMap={resolvers.resolveClassNameMap}
    model={account}
    onValidationChange={setComponentValidation}
    showErrors
    overrideProps={overrides}
    callbackMap={resolvers.resolveCallbackMap}
    componentMap={resolvers.resolveComponentMap}
/>
);
}

MLNewQuoteDialogModal.propTypes = {
    model: PropTypes.shape({}).isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired,
    indicativeUmbInd: PropTypes.bool
};

export default MLNewQuoteDialogModal;